module.exports = __webpack_public_path__ + "static/media/Dashboard react.7d5e3ec6.png";